import { calendarDaysDiff, formatDDMMYYYY, startOfUKDay } from './dateUtils';

const formatDate = (date) => {
  const parsed = date instanceof Date ? date : new Date(date);
  const formattedDate = formatDDMMYYYY(parsed);
  const now = startOfUKDay();
  const targetDate = startOfUKDay(parsed);

  const dayDifference = calendarDaysDiff(now, targetDate);

  if (dayDifference === 0) {
    return `${formattedDate} (Today)`;
  } else if (dayDifference === 1) {
    return `${formattedDate} (Yesterday)`;
  } else if (dayDifference > 1 && dayDifference <= 7) {
    return `${formattedDate} (${dayDifference} days ago)`;
  } else {
    return formattedDate;
  }
};

export default formatDate;
